import React from 'react';
import BEMHelper from '@ynap/bem-helper';
import { ProductSummary } from '@ynap/product-summary';
import { Carousel } from '@ynap/carousel';
import PropTypes from 'prop-types';
import { Link } from '@ynap/router';
import MediaQuery from '@ynap/media-query';
import { trackOriginalOutfitProducts } from '../analytics';
import { withAnalytics } from '@ynap/analytics';

const bem = new BEMHelper('WIWImageInformation');

const WIWImageInformation = (props) => {
    const { WIWProductRec, messages, carouselWidth, trackEvent, analytics } = props;
    const products = WIWProductRec?.[0]?.products || [];

    const carouselModifier = 'wiwImageCarouselStyle';

    const carouselClassNames = {
        prev: bem('arrow', 'prevModifier'),
        next: bem('arrow', 'nextModifier'),
        slideModifier: carouselModifier,
        trackModifier: carouselModifier,
        controlsModifier: carouselModifier,
    };

    const renderCarousel = (slidesToShow) => {
        return (
            <Carousel slidesToShow={slidesToShow} slidesToScroll={1} pageComponent={null} classNames={carouselClassNames}>
                {products.map((value, index) => {
                    const { image, designer, description, productId, partNumber, href, badge } = value;
                    const { primarySrcset, primary, alt } = image;
                    const isSoldOut = value?.displayable && !value?.visible;
                    const isItemUnavailable = value?.displayable === false;
                    const soldOutBadge = isSoldOut && badge;
                    const unavailableBadge = isItemUnavailable && { label: messages?.itemUnavailable?.default() };
                    const originalProductId = analytics?.product?.[0]?.productInfo?.productID;
                    const LinkComponent = isItemUnavailable ? React.Fragment : Link;

                    const trackOriginalProductEvent = () => {
                        trackEvent(trackOriginalOutfitProducts(value, index, originalProductId));
                    };

                    return (
                        <LinkComponent key={href} to={href} onClick={trackOriginalProductEvent}>
                            <div aria-disabled={isItemUnavailable} className={bem('item', { isItemUnavailable: isItemUnavailable })}>
                                <ProductSummary
                                    product={{
                                        imgSrc: {
                                            alt,
                                            primary,
                                            primarySrcset,
                                        },
                                        designerName: designer,
                                        name: description,
                                        productId,
                                        partNumber,
                                        href,
                                        badge: soldOutBadge || unavailableBadge,
                                        onSale: false,
                                    }}
                                    imageSrcsetSize="(max-width: 1024px) 40vw, 20vw"
                                    messages={messages}
                                    wiwImageInformation
                                    modifier={'wiwImageInfoStyle'}
                                    detailedView={true}
                                    hidePrice={true}
                                />
                            </div>
                        </LinkComponent>
                    );
                })}
            </Carousel>
        );
    };

    return (
        <div className={bem()} style={{ width: carouselWidth }}>
            <p className={bem('titleLinks')}>{messages?.accordionWiwInformation?.title()}</p>
            <MediaQuery
                screens={{
                    phone: () => renderCarousel(1.25),
                    tablet: () => renderCarousel(1.5),
                    desktop: () => renderCarousel(2),
                    xxlargeDesktop: () => renderCarousel(3),
                    ultraLargeDesktop: () => renderCarousel(3.5),
                }}
            />
        </div>
    );
};

WIWImageInformation.propTypes = {
    WIWProductRec: PropTypes.array.isRequired,
    messages: PropTypes.object.isRequired,
    optimizely: PropTypes.object,
    carouselWidth: PropTypes.number,
};

export default withAnalytics(WIWImageInformation);
